import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'productchemical',
  templateUrl: './productchemical.component.html',
  styleUrls: ['./productchemical.component.css']
})
export class ProductchemicalComponent implements OnInit {

  constructor() { }

  checkAllProdChemical = false;

  hmisRatings: any;
  hmisRatingsChecked = false;

  nfpaRatings: any;
  nfpaRatingsChecked = false;

  iarcMonograph: any;
  iarcMonographChecked = false;

  ACGIHCarcinogenicityNotation: any;
  ACGIHCarcinogenicityNotationChecked = false;

  transportHazardClass: any;
  transportHazardClassChecked = false;

  ngOnInit() {
  }

  onHMISRatingsChecked() {
    this.hmisRatings = '';
    if (this.hmisRatingsChecked) {
      this.hmisRatings = 'HMISRatings';
    }
  }

  onNFPARatingsChecked() {
    this.nfpaRatings = '';
    if (this.nfpaRatingsChecked) {
      this.nfpaRatings = 'NFPARatings';
    }
  }

  onIarcMonographChecked() {
    this.iarcMonograph = '';
    if (this.iarcMonographChecked) {
      this.iarcMonograph = 'IARCMonograph';
    }
  }

  onACGIHCarcinogenicityNotationChecked() {
    this.ACGIHCarcinogenicityNotation = '';
    if (this.ACGIHCarcinogenicityNotationChecked) {
      this.ACGIHCarcinogenicityNotation = 'ACGIHCarcinogenicityNotation';
    }
  }

  onTransportHazardClassesChecked() {
    this.transportHazardClass = '';
    if (this.transportHazardClassChecked) {
      this.transportHazardClass = 'TransportHazardClasses';
    }
  }

  onSelectedPhysicalChemicalChecked(event) {
    if (event.checked) {
      this.hmisRatingsChecked = true;
      if (this.hmisRatingsChecked) {
        this.onHMISRatingsChecked();
      }
      this.nfpaRatingsChecked = true;
      if (this.nfpaRatingsChecked) {
        this.onNFPARatingsChecked();
      }
      this.iarcMonographChecked = true;
      if (this.iarcMonographChecked) {
        this.onIarcMonographChecked();
      }
      this.ACGIHCarcinogenicityNotationChecked = true;
      if (this.ACGIHCarcinogenicityNotationChecked) {
        this.onACGIHCarcinogenicityNotationChecked();
      }
      this.transportHazardClassChecked = true;
      if (this.transportHazardClassChecked) {
        this.onTransportHazardClassesChecked();
      }

    } else {
      this.hmisRatingsChecked = false;
      this.hmisRatings = '';
      this.nfpaRatingsChecked = false;
      this.nfpaRatings = '';
      this.iarcMonographChecked = false;
      this.iarcMonograph = '';
      this.ACGIHCarcinogenicityNotationChecked = false;
      this.ACGIHCarcinogenicityNotation = '';
      this.transportHazardClassChecked = false;
      this.transportHazardClass = '';
    }
  }

  getCheckedValues() {
    const result = [];
    if (this.hmisRatingsChecked) { result.push(this.hmisRatings); }
    if (this.nfpaRatingsChecked) { result.push(this.nfpaRatings); }
    if (this.iarcMonographChecked) { result.push(this.iarcMonograph); }
    if (this.ACGIHCarcinogenicityNotationChecked) { result.push(this.ACGIHCarcinogenicityNotation); }
    if (this.transportHazardClassChecked) { result.push(this.transportHazardClass); }
    return result;
  }
}
